import { invertIdsByIdMap } from '@feedyou/utils'
import { DialogId, Dictionary } from '@feedyou/schema'

import {
  createNodeHierarchyMap as createNodeHierarchyMapOld,
  NodeConnections
} from '../../../lib/createNodeHierarchyMap'
import { createNodeHierarchyMap as createNodeHierarchyMapNew } from '../../../lib/createNodeHierarchyMapFast'
import { TreeEntryPoint } from './getUsedDialogsPerTreeEntryPoint'

export type DialogHierarchyDescriptor = {
  id: DialogId

  parents: Set<DialogId>
  children: Set<DialogId>
  ancestors: Set<DialogId>
  descendants: Set<DialogId>

  enabledConnectionsOnly: {
    parents: Set<DialogId>
    children: Set<DialogId>
    ancestors: Set<DialogId>
    descendants: Set<DialogId>
  }

  parentEntryPoints: Set<TreeEntryPoint>
}

export type DialogHierarchyMap = Map<DialogId, DialogHierarchyDescriptor>

export function buildDialogHierarchyMap(
  childMap: Map<DialogId, Set<DialogId>>,
  enabledConnectionsChildMap: Map<DialogId, Set<DialogId>>,
  entryPointChildMap: Dictionary<TreeEntryPoint, DialogId[]>,
  useNewAlgo: boolean
): Map<DialogId, DialogHierarchyDescriptor> {
  const createNodeHierarchyMap = useNewAlgo ? createNodeHierarchyMapNew : createNodeHierarchyMapOld
  const allConnectionsHierarchy = createNodeHierarchyMap(childMap)
  const enabledConnectionsHierarchy = createNodeHierarchyMap(enabledConnectionsChildMap)

  const parentEntryPointsPerDialogIdMap = invertIdsByIdMap(entryPointChildMap)

  const result = new Map<DialogId, DialogHierarchyDescriptor>()

  allConnectionsHierarchy.forEach((connections, dialogId) => {
    result.set(dialogId, {
      id: dialogId,
      ...connections,
      enabledConnectionsOnly:
        enabledConnectionsHierarchy.get(dialogId) ?? getEmptyNodeConnections(),
      parentEntryPoints: new Set(parentEntryPointsPerDialogIdMap[dialogId])
    })
  })

  return result
}

function getEmptyNodeConnections(): NodeConnections {
  return {
    children: new Set<DialogId>(),
    parents: new Set<DialogId>(),
    descendants: new Set<DialogId>(),
    ancestors: new Set<DialogId>()
  }
}
